module.exports.userStats = {
  vi: {
    title: 'Avalon: The Resistance | Thống kê cá nhân',
    description: 'Thống kê cá nhân các ván The Resistance: Avalon trực tuyến.',
    keywords: ['Thống kê', 'Số liệu', 'Tỷ lệ thắng'],
  },
  pt: {
    title: 'Avalon: The Resistance | Estatísticas Pessoais',
    description: "Estatísticas pessoais para jogos online em 'Avalon: The Resistance'",
    keywords: ['Estatísticas', 'Dados', 'Taxa de vitória'],
  },
  en: {
    title: 'Avalon: The Resistance | Personal Statistics',
    description: "Personal statistics for online games in 'Avalon: The Resistance'",
    keywords: ['Statistics', 'Stats', 'Winrate'],
  },
  ru: {
    title: 'Авалон: Сопротивление | Личная статистика',
    description: "Персональная статистика для онлайн-игр в 'Авалон: Сопротивление'",
    keywords: ['Статистика', 'Показатели', 'Процент побед', 'Винрейт'],
  },
  'zh-TW': {
    title: '阿瓦隆：反抗勢力 | 個人統計',
    description: '「阿瓦隆：反抗勢力」線上遊戲的個人統計數據',
    keywords: ['統計', '數據', '勝率'],
  },
  'zh-CN': {
    title: '阿瓦隆：反抗组织 | 个人统计',
    description: '《阿瓦隆：反抗组织》在线游戏的个人统计数据',
    keywords: ['统计', '数据', '胜率'],
  },
  es: {
    title: 'Avalon: La Resistencia | Estadísticas Personales',
    description: "Estadísticas personales para juegos en línea en 'Avalon: La Resistencia'",
    keywords: ['Estadísticas', 'Stats', 'Tasa de victorias'],
  },
};
